import { MakeDto } from '../models/make-dto';

export const mapMakeDto = (make): MakeDto => {
  return {
    code: make?.code,
    name: make?.name,
  };
};
